import { render, staticRenderFns } from "./PatientFieldModal.vue?vue&type=template&id=8068d90c&scoped=true"
import script from "./PatientFieldModal.vue?vue&type=script&lang=js"
export * from "./PatientFieldModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8068d90c",
  null
  
)

export default component.exports